import { decimalSeparator } from "./locale";

const patterns = new Map<string, RegExp>();

// Note: a grouping separator is refused rather than read, because Spanish groups with the full stop that
// everyone types as a decimal, and English groups with the comma that French and Spanish type as one.
export function isNumberText(text: string): boolean {
  const decimal = decimalSeparator();
  let pattern = patterns.get(decimal);
  if (!pattern) {
    const marks = decimal === "." ? "." : `.${decimal}`;
    pattern = new RegExp(`^\\s*[-+−]?\\d*(?:[${marks.replace(/[\]\\^-]/g, "\\$&")}]\\d*)?\\s*$`);
    patterns.set(decimal, pattern);
  }
  return pattern.test(text);
}

export function parseNumberText(text: string): number | null {
  if (!isNumberText(text)) return null;
  const value = Number(text.trim().replace("−", "-").replace(decimalSeparator(), "."));
  return text.trim() === "" || !Number.isFinite(value) ? null : value;
}
